export default __webpack_public_path__ + "static/media/silhouette-girl4.ce0db8a7.svg";